import DirectoryApi from '@/api/directory/directory';
import {create} from 'zustand';
import {devtools, persist} from 'zustand/middleware';

const store = (set) => {
  return {
    /** 서버에 등록된 어드민 칩 상태 */
    categoryMenu: [],
    /** 선택된 어드민 칩 */
    selectedCategoryInfo: {
      type: 'category',
      menuId: 0,
      menuName: '',
      adminId: '',
      contentsDisplay: {
        live: true,
        vod: true,
        catch: true,
      },
    },
    /** 선택된 탭 */
    selectedCategoryTab: '',
    /** 카테고리 화면의 정렬 필터 상태 */
    selectedCategoryListOrder: 'view_cnt',
    /** LIVE/VOD/Catch 탭 단위의 필터 상태 (Local Storage 저장) */
    selectedContentFilter: {
      live: [{key: 'sort', label: '조회수', type: 'view_cnt_desc'}],
      vod: [
        {key: 'sort', label: '최근 등록', type: 'reg_date'},
        {key: 'fileType', label: '전체', type: 'ALL'},
      ],
      catch: [{key: 'sort', label: '조회수', type: 'view_cnt_desc'}],
    },
    /** 기간 적용 필터의 상태 (Local Storage 미저장) */
    selectedPeriodFilter: {
      key: 'period',
      label: '1주',
      type: '1week',
      applyStatus: false,
      startDate: '',
      endDate: '',
    },
    /** 카테고리 정보 로드 완료 여부 (read-only) */
    isCategoryInfoLoaded: false,
    /** 선택된 어드민 칩을 변경한다. */
    setSelectedCategoryInfo: (selectedItem) => {
      set((state) => ({
        selectedCategoryInfo: {
          ...state.selectedCategoryInfo,
          type: selectedItem.type,
          menuId: selectedItem.menuId,
          menuName: selectedItem.menuName,
          adminId: selectedItem.adminId,
          contentsDisplay: {
            ...state.selectedCategoryInfo.contentsDisplay,
            ...selectedItem.contentsDisplay,
          },
        },
      }));
    },
    /** 선택된 어드민 칩을 "카테고리"로 초기화한다. */
    clearSelectedCategoryInfo: () => {
      set((state) => ({
        selectedCategoryInfo: {
          type: 'category',
          menuId: 0,
          menuName: '카테고리',
          adminId: '',
          contentsDisplay: {
            live: true,
            vod: true,
            catch: true,
          },
        },
      }));
    },
    setSelectedCategoryTab: (selectedItem) => {
      set((state) => {
        return {selectedCategoryTab: selectedItem};
      });
    },
    setSelectedCategoryListOrder: (selectedItem) => {
      set((state) => {
        return {selectedCategoryListOrder: selectedItem};
      });
    },
    setSelectedContentFilter: (selectedItem) => {
      set((state) => ({
        selectedContentFilter: {
          ...state.selectedContentFilter,
          ...selectedItem,
        },
      }));
    },
    /**
     * 선택한 tab의 필터 상태 변경
     * @param {'live'|'vod'|'catch'} tab
     * @param {*} selectedItem
     */
    setSelectedContentFilterByTab: (tab, selectedItem) => {
      set((state) => ({
        selectedContentFilter: {
          ...state.selectedContentFilter,
          [tab]: selectedItem,
        },
      }));
    },
    setSelectedPeriodFilter: (selectedItem) => {
      set((state) => {
        return {selectedPeriodFilter: selectedItem};
      });
    },
    /**
     * 서버로부터 어드민 칩 정보 상태를 불러온다.
     */
    async fetchCategoryMenu() {
      set((state) => {
        return {isCategoryInfoLoaded: false};
      });
      try {
        const response = await DirectoryApi.getCategoryMenu();
        if (response && response.data) {
          const categoryMenuData = response.data.list || [];
          set((state) => {
            return {categoryMenu: categoryMenuData, isCategoryInfoLoaded: true};
          });
        }
      } catch (error) {
        console.error(error);
        set((state) => {
          return {categoryMenu: []};
        });
      }
    },
  };
};

const useDirectoryStore = create(
  devtools(
    persist(store, {
      name: 'directorySelectedFilters',
      partialize: (state) => {
        return {
          selectedCategoryListOrder: state.selectedCategoryListOrder,
          selectedContentFilter: state.selectedContentFilter,
        };
      },
    }),
    {name: 'directoryStore'},
  ),
);
export default useDirectoryStore;
